import { SortingState } from "@tanstack/react-table";

import {
  COLUMN_ID_BY_RECIPIENT_SORT,
  DEFAULT_RECIPIENT_SORT,
  RECIPIENT_SORT_BY_COLUMN_ID,
  RecipientSortColumn,
  SortDirection,
} from "./constants";
import { SectorEmailsSorting } from "./filter/types";

const DESCENDING: SortDirection = "desc";
const ASCENDING: SortDirection = "asc";

export const toSortingState = (sorting: SectorEmailsSorting): SortingState => {
  const column: RecipientSortColumn = sorting.sort ?? DEFAULT_RECIPIENT_SORT;
  const columnId: string | undefined = COLUMN_ID_BY_RECIPIENT_SORT[column];

  if (!columnId) return [];

  return [{ id: columnId, desc: sorting.direction === DESCENDING }];
};

export const toRecipientSorting = (
  state: SortingState
): SectorEmailsSorting => {
  const first: SortingState[number] | undefined = state[0];

  if (!first) return {};

  const sort: RecipientSortColumn | undefined =
    RECIPIENT_SORT_BY_COLUMN_ID[first.id];

  if (!sort) return {};

  return { sort, direction: first.desc ? DESCENDING : ASCENDING };
};
